import React, { useEffect, useRef, useState } from "react";
import { HashLink as Link } from 'react-router-hash-link';
import { connect } from 'react-redux';
import { leaveHome, gotoHome, scrollTo } from '../actions';

const Header = (props) => {
    const [ mobileNavbar, setMobileNavbar ] = useState(false);
    const [ scrollHeader, setScrollHeader ] = useState(false);
    const [ section, setSection ] = useState('home');
    let NavBar = useRef();
    let aboutUsRef = useRef();
    let servicesRef = useRef();
    let portfolioRef = useRef();
    let teamRef = useRef();
    const homeTab = 'home';
    const aboutUsTab = 'aboutus';
    const servicesTab = 'services';
    const portfolioTab = 'portfolio';

    useEffect(() => {
        if(props.className === 'contact-us'){
            setSection(props.className)
        }
        if(props.pathName === `/#${aboutUsTab}`){
            setSection(aboutUsTab);
            handleClick(null, aboutUsRef);
        }else if(props.pathName === `/#${servicesTab}`){
            setSection(servicesTab);
            handleClick(null, servicesRef);
        }else if(props.pathName === `/#${portfolioTab}`){
            setSection(portfolioTab);
            handleClick(null, portfolioRef);
        }else if(props.pathName === '/#team'){
            setSection('team');
            handleClick(null, teamRef);
        }

        function handleScroll(){
            if(window.location.pathname !== "/"){
                return;
            }
            //console.log("@@@ SCROLL :", Math.floor(window.scrollY), window.location.pathname)
            if(Math.floor(window.scrollY) > 150){
                setScrollHeader(true)
            }else{
                setScrollHeader(false)
            }

            if(props.offsetList !== null){
                const aboutSection = (props.offsetList.aboutOffset - Math.floor(window.scrollY));
                const servicesSection = (props.offsetList.servicesOffset - Math.floor(window.scrollY)); 
                const portfolioSection = (props.offsetList.portfolioOffset - Math.floor(window.scrollY));
                if((aboutSection > 299) && section !== homeTab){
                    //console.log("### HOME");
                    setSection(homeTab);
                }else if((Math.sign(aboutSection) === 1) && (aboutSection < 100) && section !== aboutUsTab){
                    //console.log("SCROLL", props.offsetList.aboutOffset ,"-", Math.floor(window.scrollY), "=", (props.offsetList.aboutOffset - Math.floor(window.scrollY)), section)
                    //console.log("### ABOUT US");
                    setSection(aboutUsTab);
                }else if((Math.sign(aboutSection) === -1) && (aboutSection < -230) && section === aboutUsTab){
                    setSection('');
                }else if((Math.sign(servicesSection) === 1) && (servicesSection > 230) && section === servicesTab){
                    setSection('');
                }else if((Math.sign(servicesSection) === 1) && (servicesSection < 100) && section !== servicesTab){
                    //console.log("SCROLL", props.offsetList.servicesOffset ,"-", Math.floor(window.scrollY), "=", (props.offsetList.servicesOffset - Math.floor(window.scrollY)), section)
                    //console.log("### SERVICES");
                    setSection(servicesTab);
                }else if((Math.sign(servicesSection) === -1) && (servicesSection < -300) && section === servicesTab){
                    setSection('');
                }else if((Math.sign(portfolioSection) === 1) && (portfolioSection > 230) && section === portfolioTab){
                    setSection('');
                }else if((Math.sign(portfolioSection) === 1) && (portfolioSection < 100) && section !== portfolioTab){
                    //console.log("SCROLL", props.offsetList.portfolioOffset ,"-", Math.floor(window.scrollY), "=", (props.offsetList.portfolioOffset - Math.floor(window.scrollY)), section)
                    //console.log("### PORTFOLIO");
                    setSection(portfolioTab);
                }else if((Math.sign(portfolioSection) === -1) && (portfolioSection < -300) && section === portfolioTab){
                    setSection('');
                }
            }
        }

        window.addEventListener("scroll", handleScroll)

        return () => window.removeEventListener("scroll", handleScroll)

    }, [props.offsetList, section]);

    const handleClick = (e, ref = null) => {
        let item = null;
        if(e){
            e.preventDefault();
            item = e.currentTarget;
        }else{
            item = ref.current;
            //console.log("REF: ", item.hash.slice(1))
        }
        let menuObj = item.closest(".menu-body")
        if(menuObj){ 
            menuObj.classList.remove("show");
        }
        const id = item.getAttribute("href").slice(2);
        const section = document.getElementById(id);
        if(!section){
            return;
        }
        // console.log("ITEM ID: ", id, item.getAttribute("href"));
        // console.log("SECTION: ", section, section.offsetTop);
        let position = section.offsetTop;
        let NavBarHeight = null;
        if(e){
            NavBarHeight = NavBar.current.offsetHeight;
        }else{
            let navbar = document.getElementById("navbar");
            NavBarHeight = navbar.offsetHeight;
            props.scrollTo(null);
        }
        //console.log("### IDDDDD", menuObj, id, section, position, NavBar.current.offsetHeight)
        window.scrollTo({
            left: 0,
            top: (position - NavBarHeight)
        });
    }

    function renderNavBar(className = null){
        return (
            <div>
                <header 
                    ref={NavBar} 
                    id="header" 
                    className={
                        (scrollHeader)? 
                            "fixed-top d-flex align-items-center header-transparent header-scrolled" 
                        : 
                            (!className)? "fixed-top d-flex align-items-center header-transparent"
                            :
                                "fixed-top d-flex align-items-center"
                    }
                >
                    <div 
                        className="container d-flex justify-content-between align-items-center"
                    >
                        <div 
                            className="" 
                            onClick={(e) => {
                                e.stopPropagation();
                                window.scrollTo(0, 0);
                            }}
                        >
                            <h1 className="h2">
                                <Link 
                                    className="text-light h2" 
                                    to={"/"}
                                >
                                    DK InfoSoft
                                </Link>
                            </h1>
                        </div>
                        <nav id="navbar" className={(mobileNavbar)? 'navbar navbar-mobile' : 'navbar'}>
                            <ul>
                                <li onClick={(e) => {
                                    e.stopPropagation();
                                    props.gotoHome();
                                    window.scrollTo(0, 0)
                                }}>
                                    <Link onClick={() => setSection('home')} className={(section === 'home')? "nav-link scrollto active" : 'nav-link scrollto'} to={(className)? "/" : "/#home"}>
                                        Home
                                    </Link>
                                </li>
                                <li onClick={(e) => {
                                    e.stopPropagation();
                                }}>
                                    <Link 
                                        ref={aboutUsRef}
                                        onClick={(e) => {
                                            if(className){
                                                props.scrollTo('/#aboutus');
                                                return;
                                            }
                                            setSection('aboutus');
                                            handleClick(e);
                                        }}
                                        className={(section === 'aboutus')? "nav-link scrollto active" : 'nav-link scrollto'} 
                                        to={(className)? "/" : "/#aboutus"}
                                    >
                                        About Us
                                    </Link>
                                </li>
                                <li onClick={(e) => {
                                    e.stopPropagation();
                                }}>
                                    <Link 
                                        ref={servicesRef}
                                        onClick={(e) => {
                                            if(className){
                                                props.scrollTo('/#services');
                                                return;
                                            }
                                            setSection('services');
                                            handleClick(e);
                                        }} 
                                        to={(className)? "/" : "/#services"} 
                                        className={(section === 'services')? "nav-link scrollto active" : 'nav-link scrollto'} 
                                    >
                                        Services
                                    </Link>
                                </li>
                                <li onClick={(e) => {
                                    e.stopPropagation();
                                }}>
                                    <Link 
                                        ref={portfolioRef}
                                        onClick={(e) => {
                                            if(className){
                                                props.scrollTo('/#portfolio');
                                                return;
                                            }
                                            setSection('portfolio');
                                            handleClick(e);
                                        }} 
                                        to={(className)? "/" : "/#portfolio"} 
                                        className={(section === 'portfolio')? "nav-link scrollto active" : 'nav-link scrollto'} 
                                    >
                                        Portfolio
                                    </Link>
                                </li>
                                <li onClick={(e) => {
                                    e.stopPropagation();
                                }}>
                                    <Link 
                                        ref={teamRef}
                                        onClick={(e) => {
                                            if(className){
                                                props.scrollTo('/#team');
                                                return;
                                            }
                                            setSection('team');
                                            handleClick(e);
                                        }} 
                                        to={(className)? "/" : "/#team"} 
                                        className={(section === 'team')? "nav-link scrollto active" : 'nav-link scrollto'} 
                                    >
                                        Team
                                    </Link>
                                </li>
                                {/* <li className="dropdown"><a href="#"><span>Drop Down</span> <i className="bi bi-chevron-down"></i></a>
                                    <ul>
                                    <li><a href="#">Drop Down 1</a></li>
                                    <li className="dropdown"><a href="#"><span>Deep Drop Down</span> <i className="bi bi-chevron-right"></i></a>
                                        <ul>
                                        <li><a href="#">Deep Drop Down 1</a></li>
                                        <li><a href="#">Deep Drop Down 2</a></li>
                                        <li><a href="#">Deep Drop Down 3</a></li>
                                        <li><a href="#">Deep Drop Down 4</a></li>
                                        <li><a href="#">Deep Drop Down 5</a></li>
                                        </ul>
                                    </li>
                                    <li><a href="#">Drop Down 2</a></li>
                                    <li><a href="#">Drop Down 3</a></li>
                                    <li><a href="#">Drop Down 4</a></li>
                                    </ul>
                                </li> */}
                                <li onClick={(e) => {
                                    e.stopPropagation();
                                }}>
                                    <Link 
                                        onClick={() => {
                                            const contactus = 'contact-us';
                                            setSection(contactus)
                                        }} 
                                        to={"/contact-us"} 
                                        className={(section === 'contact-us')? "nav-link scrollto active" : 'nav-link scrollto'} 
                                    >
                                        Contact Us
                                    </Link>
                                </li>
                            </ul>
                            <i onClick={() => {
                                setMobileNavbar(!mobileNavbar)
                            }} 
                            className={(mobileNavbar)? "bi bi-x mobile-nav-toggle" : "bi bi-list mobile-nav-toggle"}></i>
                        </nav>
                    </div>
                </header>
                {(!className) && (
                    <section id="hero" className="d-flex flex-column justify-content-end align-items-center">
                        <div id="heroCarousel" className="container carousel carousel-fade" data-bs-ride="carousel" data-bs-interval="5000">
                    
                            {/* <!-- Slide 1 --> */}
                            <div className="carousel-item active">
                                <div className="carousel-container">
                                <h2 className="animate__animated animate__fadeInDown">Welcome to <span>DKinfo</span></h2>
                                <p className="animate__animated animate__fadeInUp">Ut velit est quam dolor ad a aliquid qui aliquid. Sequi ea ut et est quaerat sequi nihil ut aliquam. Occaecati alias dolorem mollitia ut. Similique ea voluptatem. Esse doloremque accusamus repellendus deleniti vel. Minus et tempore modi architecto.</p>
                                <a href="" className="btn-get-started animate__animated animate__fadeInUp">Read More</a>
                                </div>
                            </div>
                        
                            {/* <!-- Slide 2 --> */}
                            <div className="carousel-item">
                                <div className="carousel-container">
                                <h2 className="animate__animated animate__fadeInDown">Lorem Ipsum Dolor</h2>
                                <p className="animate__animated animate__fadeInUp">Ut velit est quam dolor ad a aliquid qui aliquid. Sequi ea ut et est quaerat sequi nihil ut aliquam. Occaecati alias dolorem mollitia ut. Similique ea voluptatem. Esse doloremque accusamus repellendus deleniti vel. Minus et tempore modi architecto.</p>
                                <a href="" className="btn-get-started animate__animated animate__fadeInUp">Read More</a>
                                </div>
                            </div>
                        
                            {/* <!-- Slide 3 --> */}
                            <div className="carousel-item">
                                <div className="carousel-container">
                                <h2 className="animate__animated animate__fadeInDown">Sequi ea ut et est quaerat</h2>
                                <p className="animate__animated animate__fadeInUp">Ut velit est quam dolor ad a aliquid qui aliquid. Sequi ea ut et est quaerat sequi nihil ut aliquam. Occaecati alias dolorem mollitia ut. Similique ea voluptatem. Esse doloremque accusamus repellendus deleniti vel. Minus et tempore modi architecto.</p>
                                <a href="" className="btn-get-started animate__animated animate__fadeInUp">Read More</a>
                                </div>
                            </div>
                        
                            <a className="carousel-control-prev" href="#heroCarousel" role="button" data-bs-slide="prev">
                                <span className="carousel-control-prev-icon bx bx-chevron-left" aria-hidden="true"></span>
                            </a>
                        
                            <a className="carousel-control-next" href="#heroCarousel" role="button" data-bs-slide="next">
                                <span className="carousel-control-next-icon bx bx-chevron-right" aria-hidden="true"></span>
                            </a>
                    
                        </div>
                        <svg className="hero-waves" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 28 " preserveAspectRatio="none">
                            <defs>
                                <path id="wave-path" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"/>
                            </defs>
                            <g className="wave1">
                                <use xlinkHref="#wave-path" x="50" y="3" fill="rgba(255,255,255, .1)"/>
                            </g>
                            <g className="wave2">
                                <use xlinkHref="#wave-path" x="50" y="0" fill="rgba(255,255,255, .2)"/>
                            </g>
                            <g className="wave3">
                                <use xlinkHref="#wave-path" x="50" y="9" fill="#fff"/>
                            </g>
                        </svg>
                    </section>
                )}
            </div>
        );
    }
    return (
        <div>
            {renderNavBar(props.className)}
        </div>
    )
}

const mapStateToProps = (state) => {
    //console.log("@@@ MAP STATE TO PROPS: ", state.offsetList)
    return {
        header: state.header,
        pathName: state.scrollTo,
        offsetList: state.offsetList
    }
}

export default connect(mapStateToProps, { 
    leaveHome, gotoHome, scrollTo
})(Header);